import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import "./CardUserOne.css"
import axios from "axios";
import { useSelector } from "react-redux";
import AvatarRound from "../AvatarRound";
import ErrorAdd from "../../util/ErrorAdd";

function CardUserOne({ idItem, idObject, data, idUserSelected, viewed }) {
    /*
    idItem - ИД значения объекта(ИД задачи)

    ID	Name
    1	Задача
    2	Регулярная задача
    3	Доска
    4	Проект
    5	Пользователь
    6	Регулярная задача. Трекер
    */

    const stateBoardProjectList = useSelector((state) => state.boardProjectList);
    const stateProject = useSelector((state) => state.projectList);
    const stateUserList = useSelector((state) => state.userList);
    //const stateBoardTaskList = useSelector((state) => state.boardTaskList);

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);
    const [nameUser, setNameUser] = useState(null);
    const [avatarUser, setAvatarUser] = useState(null);
    const [idUser, setIdUser] = useState(null);
    const [responibleModalShow, setResponibleModalShow] = useState(false);
    const [users, setUsers] = useState([]);
    //const [viewed, setViewed] = useState([]);

    useEffect(() => {
        if (idUserSelected !== null) {
            if (stateUserList.list.filter(a => a.ID_User === idUserSelected).length > 0) {
                setNameUser(stateUserList.list.filter(a => a.ID_User === idUserSelected)[0].Name_User);
                setAvatarUser(stateUserList.list.filter(a => a.ID_User === idUserSelected)[0].Avatar_Small);
                //setViewed()
            }
            setIdUser(idUserSelected);
        }

    }, [data, idUserSelected]);

    //console.log('stateBoardTaskList', stateBoardTaskList)
    //console.log('stateBoardProjectList', stateBoardProjectList)
    //console.log('data', data)

    //Модальное окно выбора/изменения пользователя
    function openChangeModal() {

        //ПРИ ИЗМЕНЕНИИ ЛОГИКИ МЕНЯТЬ ЕЩЕ В BoardItem - responsibleChangeModal!!!

        setResponibleModalShow(true);
        setLoading(true);
        setLog(null);

        //Настройка "Доска доступна для всех"
        const all_user_board = stateBoardProjectList.list.filter(a => a.ID_Project === data.ID_Project & a.ID_Board === data.ID_Board)[0].All_User;

        if (all_user_board === true) {

            //Настройка проекта "ДОСТУПНЫЕ ПОЛЬЗОВАТЕЛИ"
            const all_user_project = stateProject.list.filter(a => a.ID === data.ID_Project)[0].All_User;

            if (all_user_project === true) {
                setUsers(stateUserList.list.map(user => {
                    return { id_user: user.ID_User, user_name: user.Name_User, avatar: user.Avatar_Small }
                }))
            }
            else {
                var users = [];
                //Админы
                stateUserList.list.filter(a => a.ID_Role === 0 || a.ID_Role === 1).map(user => {
                    users.push({ id_user: user.ID_User, user_name: user.Name_User, avatar: user.Avatar_Small })
                })
                //Пользователи
                stateProject.listUser.filter(a => a.ID_Project === data.ID_Project).map(user => {
                    if (users.filter(a => a.id_user === user.ID_User).length === 0) {
                        users.push({
                            id_user: user.ID_User
                            , user_name: stateUserList.list.filter(a => a.ID_User === user.ID_User)[0].Name_User
                            , avatar: stateUserList.list.filter(a => a.ID_User === user.ID_User)[0].Avatar_Small
                        })
                    }
                })
                setUsers(users);
            }
            setLoading(prev => false);
        }
        else {
            setUsers(
                stateBoardProjectList.listUser.filter(a => a.ID_Board === data.ID_Board & a.ID_Project === data.ID_Project).map(user => {
                    return {
                        id_user: user.ID_User
                        , user_name: stateUserList.list.filter(a => a.ID_User === user.ID_User)[0].Name_User
                        , avatar: stateUserList.list.filter(a => a.ID_User === user.ID_User)[0].Avatar_Small
                    }
                })
            )
            setLoading(prev => false);
        }
    }

    function changeHandler(id_user, name_user) {
        if (id_user !== idUser) {
            setLoading(true);
            if (idObject === 3) {
                axios.post('/api_tracker/board/taskUpdateResponsible', { ID: idItem, ID_Responsible: id_user })
                    .then((res) => {
                        if (res.data.Status === 1) {
                            setResponibleModalShow(false);
                            setNameUser(name_user);
                            setIdUser(id_user);
                        }
                        else {
                            setLog(res.data.Error);
                        }
                        setLoading(false);
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            }
        }
    }

    return (
        <>
            {nameUser == null ? (
                <a href="" className="user_link user_no" onClick={(e) => { e.preventDefault(); openChangeModal(); }}><FontAwesomeIcon icon={faUser} className="mr-5" />Нет ответственного </a>
            ) : (
                <div className="d-flex" >
                    <div className="d-flex align-items-center" style={{ backgroundColor: '#dddfe0fc', color: 'white', padding: '2px', borderRadius: '5px' }}>
                        <AvatarRound img={avatarUser} width={20} name={nameUser} />
                        <a href="" className="user_link ml-5" onClick={(e) => { e.preventDefault(); openChangeModal(); }}>
                            {nameUser}
                            {viewed === false && <span className="badge badge-menu warning badge-dot" > </span>}
                        </a>
                    </div>
                </div>
            )}
            {responibleModalShow === true && (
                <Modal show={responibleModalShow} onHide={() => setResponibleModalShow(false)} >
                    <Modal.Body>
                        <div className="fs-4 text-center">Выберите ответственного</div>
                        {loading === true ? (
                            <div className="loader_01"></div>
                        ) : (
                            <div className="block_users mb-15 mt-15">
                                {users.sort((a, b) => a.user_name > b.user_name ? 1 : -1).map((user) => (
                                    <div key={user.id_user} className="list_item mt-10" onClick={() => changeHandler(user.id_user, user.name_user)}>
                                        <div><AvatarRound img={user.avatar} width={30} name={user.user_name} /></div>
                                        <div className="ml-5">
                                            <div className="title">{user.user_name}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                        {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                    </Modal.Body>
                </Modal >
            )
            }
        </>
    );
}
export default CardUserOne;